import { getEnv } from 'common-nextjs';
import { addHours } from 'date-fns';
import { sha1 } from 'js-sha1';
import { getKnownCookie, setKnownCookie } from '~/hooks/cookies';
import fireGAEvent from '~/services/analytics/fireGAEvent';
import fireImpactEvent from '~/services/analytics/fireImpactEvent';
import { setupAllAnalyticsLocalCapture } from '~/services/analytics/setupLocalCapture';
import identifySentryUser from '~/services/sentry/identifyUser';
import { getSentry } from '~/services/sentry/wrapper';

export const trackingIdentifyAnonymous = () => {
  setupAllAnalyticsLocalCapture();

  fireImpactEvent('identify', {
    customerId: '',
    customerEmail: '',
  });
};

export async function trackingIdentify(user: {
  username: string;
  external_id: string;
  email?: string;
  phoneNumber?: string;
}) {
  setupAllAnalyticsLocalCapture();

  if (!user) {
    return;
  }

  if (getEnv() !== 'production') {
    console.log('Analytics identified', user);
  }

  getSentry()?.setUser(identifySentryUser(user));

  if (window.amplitude) {
    window.amplitude.getInstance().setUserId(user.external_id);
    window.amplitude
      .getInstance()
      .setUserProperties({ username: user.username });
  }

  if (getEnv() === 'production') {
    fireImpactEvent('identify', {
      customerEmail: user.email ? sha1(user.email) : '',
      customerId: user.external_id || '',
    });

    fireGAEvent('set', 'userId', user.external_id);

    if (window.ttq) {
      window.ttq.identify({
        email: user.email,
        phone_number: user.phoneNumber ? sha1(user.phoneNumber) : undefined,
        external_id: user.external_id,
      });
    }
  }
}

export const trackingUnidentify = () => {
  setupAllAnalyticsLocalCapture();
  window.amplitude?.getInstance().clearUserProperties();
};

export function isFirstVisit() {
  const hasVisited = getKnownCookie(null, 'sls_fv');
  if (!hasVisited) {
    function setCookie() {
      setKnownCookie(null, 'sls_fv', '1', {
        expires: addHours(new Date(), 18),
      });
    }

    addEventListener('visibilitychange', setCookie, {
      once: true,
    });
    addEventListener('beforeunload', setCookie, {
      once: true,
    });
    addEventListener('popstate', setCookie, {
      once: true,
    });

    setTimeout(setCookie, 1500);
  }

  // if you have not yet visited, then it's your first visit (1)

  if (hasVisited) {
    return '0';
  } else {
    return '1';
  }
}
